<div dialog-header>
  <h4>Update Password</h4>
  <button class="close-btn" (click)="close()">
    <app-icon name="cross" width="16px" height="16px" />
  </button>
</div>

@if (!emailSuccess) {
  <div class="update-password-content">
    <div class="hint-password">
      <p><strong>Hint:</strong> Your password must contain</p>
      @if (data?.flowType === 'LEGACY') {
        <li>1 letter</li>
        <li>1 digit</li>
        <li>1 special character !&#64;#$%^&*_=+-/</li>
        <li>and must be at least 8 characters long.</li>
      }
      @if (data?.flowType === 'OKTA') {
        <li>one lower case letter</li>
        <li>one upper case letter</li>
        <li>one digit</li>
        <li>symbol character !&#64;#$%^&*</li>
        <li>and must be at least 12 characters long.</li>
        <li>Should not contain part of username</li>
        <li>Can not be the same like 5 previous passwords</li>
      }
    </div>
    <form [formGroup]="requestForm">
      @if (data?.actionType === 'UPDATE') {
        <app-input-control label="Current password" formControlName="currentPassword" type="password" />
      }
      <app-input-control label="New Password" formControlName="newPassword" type="password" />
      <app-input-control label="Confirm New Password" formControlName="confirmPassword" type="password" />
    </form>
  </div>
} @else {
  <p class="success-text">Your password has been updated!</p>
}

<div dialog-actions>
  @if (!emailSuccess) {
    <button ui-button (click)="updatePassword()" [disabled]="!requestForm.valid">Update Password</button>
    <button ui-button type="danger" (click)="close()">Cancel</button>
  } @else {
    <button ui-button (click)="close()">Continue</button>
  }
</div>
